import util from '@/libs/util'

const post = util.ajax.post

export const hoursUrls = [
  // 查询
  '/workinghours/list'
]

export const hours = {}

hours.list = function (params) {
  return post('/workinghours/list', params)
}
hours.insert = function (params) {
  return post('/workinghours/insert', params)
}

hours.update = function (params) {
  return post('/workinghours/update', params)
}

hours.get = function (params) {
  return post('/workinghours/get', params)
}

hours.getByName = function (params) {
  return post('/workinghours/getbyname', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/service/hours.js